import React from 'react';

import { useIntl } from 'react-intl';

import { routes } from 'navigation/routing';

import { DeliveryTermsText, TermsLink } from './styled';

export const DeliveryTerms: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <DeliveryTermsText>
      {formatMessage(
        { id: 'deliveryTerms' },
        {
          link: (
            <TermsLink to={routes.deliveryTerms} isInline>
              {formatMessage({ id: 'clickHereForDetails' })}
            </TermsLink>
          ),
        }
      )}
    </DeliveryTermsText>
  );
};
